<template>
  <div class=" user_main">
    <SettingSlider pageName="testRunner" />
    <div class="rightArea">
      <div class="contentArea">
        <div class="btnAdd" @click="onEdit('')">新增</div>
        <a-table class="table" :columns="columns" :data-source="dataList" bordered size="middle">
          <span slot="operation" slot-scope="text, record">
            <a @click="onEdit(record.id)" v-show="!canDel(record)">编辑</a>
            <a-popconfirm :disabled="canDel(record)" style="padding-left: 20px; color: red;" v-if="dataList.length"
              title="确认删除?" @confirm="() => onDelete(record.id)">
              <a :class="canDel(record) ? 'delete' : ''" href="javascript:;">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
      </div>
    </div>
    <a-modal v-model="showEdit" :title="title" @ok="handleOk">
      <div class="dialogArea">
        <div class="item">
          <span class="item_title"> 评测员账号:</span>
          <input class="borderInput" type="text" :disabled="user.id != ''" v-model="user.account" maxlength="20" />
        </div>
        <div class="item">
          <span class="item_title"> 姓名:</span>

          <input class="borderInput" type="text" v-model="user.userName" maxlength="20" />
        </div>
        <div class="item">
          <span class="item_title"> 联系电话：</span>
          <input class="borderInput" type="text" v-model="user.mobile" maxlength="20" />
        </div>
        <div class="item">
          分配角色：
          <a-radio-group v-model="user.roleCode" :options="roleList" />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import SettingSlider from "../../components/SettingSlider.vue";
import server from "../../interface/user.js";
import constants from "../../constants.js";
import storeUtil from "../../utils/storeUtil";

export default {
  name: "selfInfo",
  components: {
    SettingSlider: SettingSlider,
  },
  data() {
    return {
      showEdit: false,
      dataList: [],

      title: "编辑评测员",
      user: {
        id: "",
        account: "",
        userName: "",
        mobile: "",
        roleCode: "",
      },
      columns: [
        {
          title: "",
          dataIndex: "",
          key: "",
          width: "2%",
        },
        {
          title: "姓名",
          dataIndex: "account",
          key: "account",
        },
        // {
        //   title: "责任人",
        //   dataIndex: "userName",
        //   key: "userName",
        // },
        {
          title: "联系电话",
          dataIndex: "mobile",
          key: "mobile",
        },
        {
          title: "角色",
          dataIndex: "roleCodeStr",
          key: "roleCodeStr",
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: {
            customRender: "operation",
          },
        },
        {
          title: "",
          dataIndex: "",
          key: "",
          width: "2%",
        },
      ],
      roleList: [
        {
          label: "评测员",
          value: constants.role_testReview,
        },
        {
          label: "初审",
          value: constants.role_primaryReview,
        },
        {
          label: "终审",
          value: constants.role_finalReview,
        },
        // {
        //   label: "系统管理员",
        //   value: constants.role_sysAdmin,
        //             }
      ],
    };
  },
  mounted() {
    this.getAllUser();
  },
  methods: {
    canDel(data) {
      return data.roleCode == constants.role_sysAdmin;
    },
    onEdit(id) {
      if (id == "") {
        this.title = "新增评测员";
        this.user.id = "";
        this.user.account = "";
        this.user.userName = "";
        this.user.mobile = "";
        this.user.roleCode = constants.role_testReview;
      } else {
        for (var i = 0; i < this.dataList.length; ++i) {
          if (id == this.dataList[i].id) {
            this.user.id = id;
            this.user.account = this.dataList[i].account;
            this.user.userName = this.dataList[i].userName;
            this.user.mobile = this.dataList[i].mobile;
            this.user.roleCode = this.dataList[i].roleCode;
          }
        }
        this.title = "编辑用户信息";
      }
      this.showEdit = true;
    },
    onDelete(id) {
      server
        .deleteUser(id)
        .then((result) => {
          console.log(result);
          this.getAllUser();
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    roleCode2Name(code) {
      if (code == constants.role_unit) {
        return "责任单位";
      } else if (code == constants.role_primaryReview) {
        return "初审";
      } else if (code == constants.role_finalReview) {
        return "终审";
      } else if (code == constants.role_sysAdmin) {
        return "系统管理员";
      } else if (code == constants.role_testReview) {
        return "评测员";
      }
    },
    getAllUser() {
      server
        .getAllUsers({
          roleCode: "",
        })
        .then((result) => {
          this.dataList = result;
          this.dataList = this.dataList.filter((item) => {
            return item.roleCode != constants.role_unit;
          });

          for (let i = 0; i < this.dataList.length; ++i) {
            this.dataList[i].roleCodeStr = this.roleCode2Name(
              this.dataList[i].roleCode
            );
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleOk() {
      if (!this.user.account) {
        this.$message.error("账号不能为空");
        return
      } if (!this.user.userName) {
        this.$message.error("姓名不能为空");
        return
      }

      let phone = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/;
      if (!phone.test(this.user.mobile)) {
        this.$message.error("请检查手机号码");
        return;
      }

      if (!this.user.roleCode) {
        this.$message.error("账号角色不能为空");
        return;
      }
      console.log(this.user);
      if (this.user.id == "") {
        server
          .addUser(this.user)
          .then((result) => {
            console.log(result);
            this.showEdit = false;
            this.getAllUser();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } else {
        server
          .updateUser(this.user)
          .then((result) => {
            console.log(result);
            this.showEdit = false;
            this.getAllUser();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }
    },
  },
  isme() {
    console.log("检测是否自身条目");
    var userinfo = storeUtil.getUserInfo();
    console.log(userinfo);
    console.log(this.user);
    return !(userinfo.id == this.user.id);
  },
};
</script>
<style scoped lang="less">
.user_main {
  display: flex;
  height: 984px;
}

.rightArea {
  background-color: #f6f9fc;
  height: (1080 - 96) px;
  border-top: 1px #f6f9fc solid;
  flex: 1;

  .contentArea {
    height: 888px;
    margin-left: 25px;
    margin-right: 58px;
    margin-top: 48px;
    overflow: auto;

    /* line-height 和 height 相等使文字垂直居中 */
    .btnAdd {
      cursor: pointer;
      background-color: #4265ed;
      width: 200px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      margin-bottom: 20px;
      border-radius: 3px;
      color: #ffffff;
      font-family: "Source Han Sans CN";
      font-weight: 500;
      font-size: 20px;
    }

    .table {
      padding: 30px;
      background-color: white;
      height: 800px;

      .delete {
        display: none;
      }
    }
  }
}

.dialogArea {
  margin-top: 10px;
  margin-bottom: 10px;

  .item {
    margin-top: 38px;
    margin-left: 58px;

    .item_title {
      display: inline-block;
      width: 7rem;
    }

    .text {
      margin-left: 40px;
    }

    .borderInput {
      margin-left: 5px;
      outline: none;
      border: none;
      border-bottom: 1px solid #aaaaaa;
    }
  }
}
</style>
